import React from "react";
//Main Routing Components
import MainPage, { tagsLoader } from "containers/MainPage";
import SettingsContainer from "containers/SettingsContainer";
import { Navigate } from "react-router";

import { landingPageStrings } from "constants/constantStrings";
import ROUTES_PATH, { SETTINGS_PAGES, SYSTEMS_PAGES } from "constants/pages.constant";

import AccountSettings from "pages/AccountSettings";
import AlarmTabs from "pages/Alarms";
import Analytics from "pages/Analytics";
import Baseline from "pages/Baseline";
import ChartView from "pages/Chart";
//Systems Components
import Dashboard from "pages/Dashboard";
import Logout from "pages/Logout";
import NotAuthorized from "pages/NotAuthorized";
import NotificationSettings from "pages/Notifications";
import Report from "pages/Report";
import ReportsHistory from "pages/ReportsHistory";
import InsightTabs from "pages/SmartInsight";
import SystemDevices from "pages/Systems";
import SystemsAndAlarms from "pages/SystemsAndAlarms";
import TagList from "pages/TagList";
//  Settings Components
import AddUsers from "pages/Users";

import RootLayout from "./containers/RootLayout";

function ErrorComponent() {
  return (
    <div className="app-wrapper text-center">
      <div className="error-container">{landingPageStrings.tryAgain}</div>
    </div>
  );
}

const APP_ROUTES = [
  {
    path: ROUTES_PATH.DEFAULT,
    element: <RootLayout />,
    errorElement: <ErrorComponent />,
    children: [
      { path: ROUTES_PATH.HOME, element: <SystemsAndAlarms /> },
      {
        path: ROUTES_PATH.SYSTEMS,
        element: <MainPage />,
        loader: tagsLoader,
        children: [
          {
            path: SYSTEMS_PAGES.DASHBOARDS,
            element: <Dashboard />
          },
          {
            path: SYSTEMS_PAGES.CHARTS,
            element: <ChartView />
          },
          {
            path: SYSTEMS_PAGES.REPORTS,
            element: <Report />
          },
          {
            path: SYSTEMS_PAGES.ANALYTICS,
            element: <Analytics />
          },
          {
            path: SYSTEMS_PAGES.REPORTS_HISTORY,
            element: <ReportsHistory />
          },
          {
            path: SYSTEMS_PAGES.INSIGHTS,
            element: <InsightTabs />
          },
          {
            path: SYSTEMS_PAGES.ALARMS,
            element: <AlarmTabs />
          },
          {
            path: SYSTEMS_PAGES.TAGS,
            element: <TagList />
          },
          {
            path: SYSTEMS_PAGES.BASELINES,
            element: <Baseline />
          }
        ]
      },
      {
        path: ROUTES_PATH.SETTINGS,
        element: <SettingsContainer />,
        children: [
          { path: SETTINGS_PAGES.ACCOUNT, element: <AccountSettings /> },
          { path: SETTINGS_PAGES.NOTIFICATION, element: <NotificationSettings /> },
          { path: SETTINGS_PAGES.USERS, element: <AddUsers /> },
          { path: SETTINGS_PAGES.SYSTEMS, element: <SystemDevices /> }
        ]
      },
      {
        path: ROUTES_PATH.LOGOUT,
        element: <Logout />
      },
      {
        path: ROUTES_PATH.UNUTHORIZED,
        element: <NotAuthorized />
      },
      {
        path: ROUTES_PATH.WILDCARD,
        element: <Navigate replace to={ROUTES_PATH.HOME} />
      }
    ]
  }
];

export default APP_ROUTES;
